import { Injectable } from '@angular/core';

/** === Addins === */
import { Router } from '@angular/router';

/** RXJS  */
import { BehaviorSubject } from 'rxjs';
//services
import { StorageService } from './storage.service'
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public user = new BehaviorSubject<any>( {} ); 
  constructor(
    private router : Router, 
    private storage : StorageService, 
  ) { 
   

    this.setUser();
    
  }

  async setUser(){
    let userData = await this.storage.get('user');
    this.user.next( userData );
    // console.log("🚀 ~ file: auth.service.ts:29 ~ AuthService ~ setUser ~ userData:", userData)
  }

  /**
   * isLoggedIn
   * returns bool based on storage of token
   */
  async isLoggedIn(): Promise<boolean>
  {
    await this.storage.init();

    return this.storage.get('token').then((val : string) => { // <-- Here!
  
      // console.log("AuthService -> 'isLoggedIn: ' + val", 'isLoggedIn: ' + val)
      if(!val || val == null)
      {
        return false;
      }
      return true;
    });
  }//end isLoggedIn()

    /**
  * 
  * @param data object
  * saves user from ata object to storage
  */
    public saveValidUser( userData : any ){

      return new Promise((resolve) => {
      
        Promise.all([ 
          //this.storage.set('user', user);
          //set local storage for user
          
          this.storage.get('userId'),
          this.storage.set('userId', userData.user.id ),
          //token
          this.storage.set('token', userData.access_token ),
  
          this.storage.set('user', userData.user),
          this.storage.set('permissions', userData.permissions),
  
          this.user.next( userData.user ),
        ]).then( ( data ) =>{
  
          if( data[0] != userData.user.userId ){
            //if its a diff user then clear assessments
            //check if old user if this user . i.e. have not signed out and relogging in for some reason (token timeout?)
            
  
          }else{
            // // console.log("AuthService -> saveValidUser -> 'same user came back'", 'same user came back')
          }
          resolve( true );
        });
      });
  
                   
    }

    /**
   * signOut
   * removes all user info from storage and redirects to signin
   */
    public signout(): void{

      this.storage.remove('userId');
      this.storage.remove('user');
      this.storage.remove('permissions');
      this.storage.remove('token');
      this.storage.remove('assessments');
      this.storage.remove('token');
      this.storage.remove('defs');
      //this.sqlService.deleteAllAssessments();
      this.router.navigate(['/signin']);

    }


}
